import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { goBack } from 'src/app/common/common';
import { SchedulerTask } from 'src/app/model/scheduler.model';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';

@Component({
  selector: 'app-create-scheduler-index',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './create-scheduler.component.html',
  styleUrl: './create-scheduler.component.scss'
})
export class CreateSchedulerComponent implements OnInit {

  // FORM with validation requirements matching Venway2
  schedulerTaskForm = new FormGroup({
    name: new FormControl<string>('', [Validators.required]),
    url: new FormControl<string>('', [Validators.required]),
    rate: new FormControl<number>(0, [Validators.required]),
    start: new FormControl<string>(''),
    type: new FormControl<string>('http_get'),
  });

  public editing: boolean = false;
  public schedulerId: string;
  public router: Router;
  public task: SchedulerTask = {
    id: 0,
    name: '',
    rate: 0,
    start: '',
    type: 'http_get',
    params: {
      url: ''
    }
  }
  public error: string | null = null;

  constructor(private injector: Injector, private createSchedulerService: ApiService) {
    this.router = injector.get(Router);
    this.router.events.subscribe((event: any) => {
      if (event?.snapshot?.params.id) {
        this.editing = true;
        this.schedulerId = event.snapshot.params.id;
      }
    });
  }

  setFormsDefaultValue() {
    this.schedulerTaskForm.controls.name.setValue(this.task?.name);
    this.schedulerTaskForm.controls.url.setValue(this.task?.params?.url);
    this.schedulerTaskForm.controls.rate.setValue(this.task?.rate);
    this.schedulerTaskForm.controls.start.setValue(this.task?.start);
    this.schedulerTaskForm.controls.type.setValue(this.task?.type);

    if (this.editing) {
      this.schedulerTaskForm.controls.name.disable();
    }
  }

  ngOnInit(): void {
    if (this.editing) {
      const queryParam: CustomHttpParams = {
        'depth': 1,
        'name': this.schedulerId
      }
      this.createSchedulerService.getSchedulerTasks(queryParam).subscribe({
        next: (response: any) => {
          this.task = response.find((task: SchedulerTask) => task.name === this.schedulerId) || this.task;
          this.setFormsDefaultValue();
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    } else {
      // Default values for new tasks
      this.task.type = 'http_get';
    }

    // Subscribe to form value changes to update task object
    this.schedulerTaskForm.valueChanges.subscribe(values => {
      if (values.name) this.task.name = values.name;
      if (values.url) this.task.params.url = values.url;
      if (values.rate) this.task.rate = Number(values.rate);
      if (values.start) this.task.start = values.start;
      if (values.type) this.task.type = values.type;
    });
  }

  save() {
    // Validate form
    if (this.schedulerTaskForm.invalid) {
      this.error = 'Please fill out all fields correctly and try again.';
      return;
    }

    if (this.editing) {
      this.createSchedulerService.editSchedulerTaskss(this.task).subscribe({
        next: () => {
          goBack('/scheduler', this.router);
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    } else {
      delete this.task.id;
      this.createSchedulerService.createSchedulerTasks(this.task).subscribe({
        next: () => {
          goBack('/scheduler', this.router);
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    }
  }

  backPage(url: string, router: Router) {
    goBack(url, router);
  }
}
